import Tobii from '@midzer/tobii'
import '../../../node_modules/@midzer/tobii/dist/tobii.min.css'

const initLightbox = (
    {
        navLabel,
        closeLabel,
        loadingIndicatorLabel,
        zoom,
        captions
    } = {}
) => {
    new Tobii({
        navLabel: ['Zurück', 'Weiter'],
        closeLabel: 'Bildvergrößerung schließen',
        loadingIndicatorLabel: 'Bild wird geladen',
        zoom: false,
        captions: false
    });
}

export default initLightbox
